<template>
  <div
    class="e-flex e-flex-wrap e-justify-center e-h-full e-w-full position-relative e-p-2"
  >
    <KitZohoDeskTicketsCard :dialog.sync="dialog" />
    <v-dialog
      v-model="dialog"
      transition="none"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      content-class="h-90 w-90"
    >
      <KitZohoDeskTicketsCard :dialog.sync="dialog" />
    </v-dialog>
  </div>
</template>

<script>
import KitZohoDeskTicketsCard from "@/components/kits/KitZohoDeskTicketsCard"

export default {
  name: "KitZohoDeskTickets",
  components: { KitZohoDeskTicketsCard },
  data() {
    return {
      dialog: false,
    }
  },
}
</script>
